import React, { useEffect, useState } from "react";
import { MainButton, MainLink, TextRegular, Title, SecondaryButton } from "../../styles/GlobalStyledComponents";
import { UnknowErrorImage } from "./NoDataBkrStyledComponents";

import DataMiss from "../../assets/images/DataMiss.svg";
import IbanSelection from "../IbanSelection/IbanSelection";


interface NoDataBkrProps {
  ibanList: string[];
  selectBankreader: () => void;
  loadingEvent: (data: boolean) => void;
}

export const NoDataBkr: React.FC<NoDataBkrProps> = ({ ibanList, selectBankreader, loadingEvent }) => {
  const [shownibanList, setShowIbanList] = useState<string[]>([])
  const [showIbanSelector, setShowIbanSelector] = useState(false)

  const handleContinue = async () => {
    setShowIbanList(ibanList)
    setShowIbanSelector(true)
  };

  useEffect(() => {
    loadingEvent(false);
  }, [loadingEvent]);

  return <>
    <Title id="unknown-error-title">¿Nos faltan datos?</Title>
    <TextRegular $fontSize={14} $align='center'>No hemos detectado tus ingresos en este banco</TextRegular>
    <TextRegular $fontSize={14} $align='center'>Te recomendamos selecionar el banco donde recibes tu nomina o pension</TextRegular>

    <UnknowErrorImage src={DataMiss}></UnknowErrorImage>
    <MainButton id="unknown-error-return-btn" onClick={selectBankreader}>Seleccionar otro banco</MainButton>
    <SecondaryButton id="unknown-error-return-btn" onClick={handleContinue}>Continuar con este banco</SecondaryButton>
    {showIbanSelector && shownibanList && <IbanSelection ibanList={shownibanList} loadingEvent={loadingEvent}></IbanSelection>}
  </>
};
